<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.drug', 2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card-title">
                    <router-link :to="{ name: 'add-drug' }" v-if="can">
                        {{ $t('message.add') }}

                        <i class="fas fa-plus-circle edit-icon"></i>
                    </router-link>
                </div>

                <b-container>
                    <b-row class="justify-content-sm-center">
                        <b-col col sm="12">
                            <vue-good-table
                                    id="operation"
                                    :columns="drugsColumns"
                                    :rows="mDrugsRow"
                                    :search-options="{
                                        enabled:true,
                                        }"
                                    :pagination-options="paginationOptions"
                                    @on-row-click="onDrugClick"
                            />
                        </b-col>
                    </b-row>
                </b-container>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "Drugs",
        computed: {
            ...mapGetters(["drugs",'hasPatientRole','hasSouscripteurRole']),

            can:function () {
                return !this.hasPatientRole && !this.hasSouscripteurRole;
            },

            mDrugsRow:function () {
                return this.drugs;
            }
        },

        data(){
            return {

                drugsColumns: [
                    {
                        field: 'nom_commercial',
                        label: this.$i18n.t('message.tradeName'),
                    },
                    {
                        field: 'principe_actif',
                        label: this.$i18n.t('message.activeSubstance'),
                    },
                    {
                        field: 'classe_medicamenteuse',
                        label: this.$i18n.t('message.therapeuticClass'),
                    },
                    {
                        field: 'forme_et_dosage',
                        label: this.$i18n.t('message.dosage'),
                    },
                    {
                        field: 'conditionement',
                        label: this.$i18n.t('message.packaging'),
                    },
                ],

                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [10, 15, 20]
                },
            }
        },
        methods:{
            onDrugClick(params){
                this.$router.push({ name: 'drug', params: { drug: params.row.slug } });
            },

            listeDesMedicaments() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getDrugs', { args : args });
            },
        },

        mounted() {
            this.listeDesMedicaments();
        }
    }
</script>

<style scoped>

</style>